<script>
    import Icon from '../icons/Icon.svelte';

    export let operatingSchedule = [
        { day_of_week: 1, day_name: 'Segunda-feira', open_time: '18:00', close_time: '23:30', is_closed: false },
        { day_of_week: 2, day_name: 'Terça-feira', open_time: '18:00', close_time: '23:30', is_closed: false },
        { day_of_week: 3, day_name: 'Quarta-feira', open_time: '18:00', close_time: '23:30', is_closed: false },
        { day_of_week: 4, day_name: 'Quinta-feira', open_time: '18:00', close_time: '23:30', is_closed: false },
        { day_of_week: 5, day_name: 'Sexta-feira', open_time: '18:00', close_time: '00:00', is_closed: false },
        { day_of_week: 6, day_name: 'Sábado', open_time: '18:00', close_time: '00:00', is_closed: false },
        { day_of_week: 0, day_name: 'Domingo', open_time: '18:00', close_time: '23:30', is_closed: false }
    ];
    export let closedMessage = '';
    export let onApplyWeekdaySchedule = () => {};
</script>

<div class="tab-pane">
    <section class="settings-card">
        <div class="card-header schedule-header">
            <div>
                <div class="card-title-group">
                    <Icon name="clock" size={18} />
                    <h4>Horários de Atendimento Semanal</h4>
                </div>
                <span class="card-subtitle">O cardápio digital e o robô do WhatsApp respeitam rigorosamente essa grade para aceitar pedidos.</span>
            </div>
            <button type="button" class="btn-copy-schedule" on:click={onApplyWeekdaySchedule}>
                <Icon name="copy" size={14} />
                <span>Copiar Seg para Dias Úteis</span>
            </button>
        </div>

        <div class="days-list">
            {#each operatingSchedule as item, idx}
                <div class="day-row {item.is_closed ? 'day-closed' : ''}">
                    <div class="day-name-box">
                        <label class="day-toggle-label">
                            <input type="checkbox" bind:checked={item.is_closed} />
                            <span class="custom-check-pill {item.is_closed ? 'closed' : 'open'}">
                                {item.is_closed ? 'Fechado' : 'Aberto'}
                            </span>
                        </label>
                        <span class="day-label">{item.day_name}</span>
                    </div>

                    {#if !item.is_closed}
                        <div class="time-inputs-row">
                            <div class="time-field">
                                <label for="open-{idx}">Abertura</label>
                                <input
                                    id="open-{idx}"
                                    type="time"
                                    bind:value={item.open_time}
                                    class="time-input"
                                />
                            </div>
                            <span class="time-sep">às</span>
                            <div class="time-field">
                                <label for="close-{idx}">Fechamento</label>
                                <input
                                    id="close-{idx}"
                                    type="time"
                                    bind:value={item.close_time}
                                    class="time-input"
                                />
                            </div>
                        </div>
                    {:else}
                        <span class="closed-notice">Estabelecimento não atende neste dia</span>
                    {/if}
                </div>
            {/each}
        </div>
    </section>

    <!-- 2. Mensagem de Loja Fechada -->
    <section class="settings-card">
        <div class="card-header">
            <div class="card-title-group">
                <Icon name="moon" size={18} />
                <h4>Mensagem Automática Fora do Expediente</h4>
            </div>
            <span class="card-subtitle">Esta mensagem é enviada pelo robô do WhatsApp e exibida no banner do cardápio quando a loja estiver fechada.</span>
        </div>

        <div class="form-group">
            <label for="closed-msg">Texto Personalizado para Clientes</label>
            <textarea
                id="closed-msg"
                rows="3"
                bind:value={closedMessage}
                placeholder="Olá! Nosso estabelecimento está fechado no momento. Nosso horário de atendimento é de terça a domingo das 18h às 23h30. Deixe sua mensagem que responderemos assim que abrirmos!"
                class="form-textarea"
            ></textarea>
            <small class="textarea-hint">Dica: Se deixar em branco, o sistema usará a mensagem padrão do MataFome informando o próximo horário de abertura.</small>
        </div>
    </section>
</div>

<style>
    .tab-pane {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .settings-card {
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        padding: 22px 24px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
    }

    .card-header {
        margin-bottom: 16px;
    }

    .schedule-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;
    }

    .card-title-group {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #0F172A;
    }

    .card-title-group h4 {
        font-size: 0.98rem;
        font-weight: 700;
        margin: 0;
        color: #0F172A;
    }

    .card-subtitle {
        font-size: 0.82rem;
        color: #64748B;
        display: block;
        margin-top: 4px;
    }

    .btn-copy-schedule {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        color: #334155;
        padding: 7px 14px;
        border-radius: 6px;
        font-size: 0.8rem;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        transition: all 0.2s;
    }

    .btn-copy-schedule:hover {
        background: #FFF7ED;
        border-color: #FF6A00;
        color: #EA580C;
    }

    .days-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .day-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        border-radius: 8px;
        padding: 10px 16px;
        gap: 14px;
        flex-wrap: wrap;
        transition: all 0.2s;
    }

    .day-row.day-closed {
        opacity: 0.75;
        background: #F1F5F9;
        border-color: #CBD5E1;
    }

    .day-name-box {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 180px;
    }

    .day-toggle-label {
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .day-toggle-label input {
        display: none;
    }

    .custom-check-pill {
        font-size: 0.7rem;
        font-weight: 700;
        padding: 4px 10px;
        border-radius: 20px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        transition: all 0.2s;
    }

    .custom-check-pill.open {
        background: #DCFCE7;
        color: #166534;
        border: 1px solid #BBF7D0;
    }

    .custom-check-pill.closed {
        background: #FEE2E2;
        color: #991B1B;
        border: 1px solid #FECACA;
    }

    .day-label {
        font-size: 0.88rem;
        font-weight: 700;
        color: #0F172A;
    }

    .time-inputs-row {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .time-field {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .time-field label {
        font-size: 0.74rem;
        font-weight: 600;
        color: #64748B;
    }

    .time-input {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 6px;
        padding: 6px 10px;
        color: #0F172A;
        font-family: monospace;
        font-size: 0.84rem;
    }

    .time-input:focus {
        outline: none;
        border-color: #FF6A00;
        box-shadow: 0 0 0 2px rgba(255, 106, 0, 0.15);
    }

    .time-sep {
        font-size: 0.78rem;
        color: #94A3B8;
    }

    .closed-notice {
        font-size: 0.78rem;
        color: #94A3B8;
        font-style: italic;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .form-group label {
        font-size: 0.78rem;
        font-weight: 600;
        color: #475569;
    }

    .form-textarea {
        background: #FFFFFF;
        border: 1px solid #CBD5E1;
        border-radius: 8px;
        padding: 10px 14px;
        color: #0F172A;
        font-size: 0.86rem;
        line-height: 1.45;
        resize: vertical;
        transition: all 0.2s ease;
    }

    .form-textarea:focus {
        outline: none;
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
    }

    .textarea-hint {
        font-size: 0.74rem;
        color: #64748B;
    }
</style>
